module.exports = __webpack_public_path__ + "static/media/loader.e92263d5.svg";